import axios from "axios";
import protobuf from "protobufjs";
import StickersProto from "../etc/stickers-proto.js";
function StickersClientFactory(options) {
  const { decryptManifest, base64Encoder } = options;
  const packMessage = protobuf.Root.fromJSON(StickersProto).root.lookupType("Pack");
  const stickerPackManifestCache = /* @__PURE__ */ new Map();
  const stickerImageCache = /* @__PURE__ */ new Map();
  const parseManifest = async (key, rawManifest) => {
    try {
      const manifest = await decryptManifest(key, rawManifest);
      const manifestData = new Uint8Array(manifest, 0, manifest.byteLength);
      return packMessage.decode(manifestData);
    } catch (err) {
      const newErr = new Error(`[parseManifest] ${err.stack}`);
      err.code = "MANIFEST_PARSE";
      throw newErr;
    }
  };
  const getStickerPackManifest = async (id, key) => {
    const cacheKey = `${id}-${key}`;
    if (!stickerPackManifestCache.has(cacheKey)) {
      stickerPackManifestCache.set(cacheKey, new Promise(async (resolve, reject) => {
        try {
          const res = await axios({
            method: "GET",
            responseType: "arraybuffer",
            url: `https://cdn-ca.signal.org/stickers/${id}/manifest.proto`
          });
          const manifest = await parseManifest(key, res.data);
          resolve(manifest);
        } catch (err) {
          reject(err);
        }
      }));
    }
    return stickerPackManifestCache.get(cacheKey);
  };
  const getStickerInPack = async (id, key, stickerId, encoding = "raw") => {
    const cacheKey = `${id}-${key}-${stickerId}`;
    if (!stickerImageCache.has(cacheKey)) {
      stickerImageCache.set(cacheKey, new Promise(async (resolve, reject) => {
        try {
          const res = await axios({
            method: "GET",
            responseType: "arraybuffer",
            url: `https://cdn-ca.signal.org/stickers/${id}/full/${stickerId}`
          });
          const stickerManifest = await decryptManifest(key, res.data);
          const rawWebpData = new Uint8Array(stickerManifest, 0, stickerManifest.byteLength);
          resolve(rawWebpData);
        } catch (err) {
          reject(err);
        }
      }));
    }
    const rawImageData = await stickerImageCache.get(cacheKey);
    if (encoding === "raw") {
      return rawImageData;
    }
    const base64Data = base64Encoder(String.fromCodePoint(...rawImageData));
    return `data:image/webp;base64,${base64Data}`;
  };
  const getEmojiForSticker = async (id, key, stickerId) => {
    const packManifest = await getStickerPackManifest(id, key);
    const sticker = packManifest.stickers.find((curSticker) => curSticker.id === stickerId);
    if (!sticker) {
      throw new Error(`Sticker pack ${id} has no sticker with ID ${stickerId}.`);
    }
    return sticker.emoji;
  };
  return {
    getStickerPackManifest,
    getStickerInPack,
    getEmojiForSticker
  };
}
export {
  StickersClientFactory as default
};
//# sourceMappingURL=stickers-client.js.map
